// @flow

import build from "redux-object";
import normalize from "json-api-normalizer";
import camel from "lodash/camelCase";

const buildObject = (normalized: any, type: string, id: string | number) =>
  build(normalized, camel(type), Number(id), { includeType: true });

// eslint-disable-next-line import/prefer-default-export
export const denormalizeJsonApi = (response: { data: any }) => {
  if (!response) {
    return null;
  }

  const responseData =
    typeof response.data === "string" ? JSON.parse(response.data) : response.data;
  const targetData = responseData.data;

  if (!targetData) {
    return null;
  }

  try {
    const normalized = normalize(responseData);
    return targetData instanceof Array
      ? targetData.map(item => buildObject(normalized, item.type, item.id))
      : buildObject(normalized, targetData.type, targetData.id);
  } catch (err) {
    return null;
  }
};

export const extractPagination = (response: { headers: Object }) =>
  response && response.headers
    ? {
        current: Number(response.headers["x-page"]),
        prev: Number(response.headers["x-prev-page"]) || null,
        next: Number(response.headers["x-next-page"]) || null,
        totalPages: Number(response.headers["x-total-pages"]),
        itemsPerPage: Number(response.headers["x-per-page"]),
        totalItems: Number(response.headers["x-total"]),
        offset: Number(response.headers["x-offset"])
      }
    : {};

export const extractMeta = (response: { data?: { meta?: any } }) =>
  !response || !response.data ? null : response.data.meta || null;

export const extractCountByCompany = (response: { data?: { meta?: any } }) => {
  const metaArray = extractMeta(response);
  if (!metaArray || !metaArray.length) {
    return null;
  }
  return metaArray[0].by_company.count;
};
